import { getStackList } from './stack';

export default function handlerErrorParams(params: any) {
  const newParams = { ...params };
  if (newParams.error && newParams.error instanceof Error) {
    newParams.stack_list = getStackList(newParams.error);
    delete newParams.error;
  }
  return newParams;
}
